/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getArrayItems } from '../../utils/FormatFunctions';

export function AssessmentsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/ratings`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'rating_topics', label: 'Tópicos' },
  ];

  return (
    <Box>
      <PageTitle>Avaliações</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        formatColum={[
          {
            field: 'rating_topics',
            formatField: getArrayItems,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />
    </Box>
  );
}
